import { createLogger, format, transports } from 'winston'
const { timestamp, combine, printf, errors } = format

export function buildDevLogger() {
  const logFormat = printf(({ level, message, timestamp, stack }) => {
    return `${timestamp} ${level}: ${stack || message}`
  })

  return createLogger({
    format: combine(
      format.colorize(),
      timestamp({ format: 'DD-MM-YYYY HH:mm:ss' }),
      errors({ stack: true }),
      logFormat
    ),
    transports: [new transports.Console()],
  })
}
